import React from 'react';
export function ClaimRejectedDealerTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-255">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-256">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-257" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-258">
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
      }} data-id="element-259">
          <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          margin: '0'
        }} data-id="element-260">
            Claim rejected
          </h1>
          <span style={{
          fontSize: '13px',
          fontWeight: '600',
          color: '#2563eb',
          backgroundColor: '#eff6ff',
          padding: '4px 12px',
          borderRadius: '4px',
          border: '1px solid #bfdbfe'
        }} data-id="element-261">
            {2025240691}
          </span>
        </div>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '8px'
      }} data-id="element-262">
          Hello <strong data-id="element-263">CANAGRO EXPORTS INC.</strong>,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-264">
          After careful review, <strong data-id="element-265">Aisco Europe</strong> has decided not to
          approve this claim. Please see the detailed explanation below.
        </p>

        {/* Rejection Notice */}
        <div style={{
        backgroundColor: '#fef2f2',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #ef4444',
        marginBottom: '32px'
      }} data-id="element-266">
          <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#991b1b',
          marginTop: '0',
          marginBottom: '8px'
        }} data-id="element-267">
            Claim Not Approved
          </h3>
          <p style={{
          margin: '0',
          color: '#b91c1c',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-268">
            This claim has been reviewed and rejected. A detailed explanation is
            provided below.
          </p>
        </div>

        {/* Rejection Explanation */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '32px'
      }} data-id="element-269">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-270">
            Rejection Explanation
          </h3>
          <p style={{
          margin: '0',
          color: '#4b5563',
          fontSize: '14px',
          lineHeight: '1.8'
        }} data-id="element-271">
            It is almost normal to see some leakage of oil on a new gearbox
            during the first months of use and even before starting the
            irrigation. This is generally due to an extra quantity of oil inside
            the gearbox when it has been full at UMC manufacture. Because of the
            change of temperature and because the metallic gearboxes and the oil
            itself have a different dilatation coefficient, the extra quantity
            of oil goes out of the gearbox through the seals. After several
            months of work, the leakage should disappear. If you customer is
            insistent, I suggest him or your technical man to open the
            rectangular cover above the gearbox and have a look to the oil level
            inside the gearbox. Just make sure that the worm part is still
            completely cover by oil. You might change the gearbox by another one
            only if a large quantity of oil is missing.
          </p>
        </div>

        {/* Claim Details */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '24px'
      }} data-id="element-272">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-273">
            Claim Information
          </h3>
          <div style={{
          display: 'grid',
          gap: '12px'
        }} data-id="element-274">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-275">
              <span style={{
              color: '#6b7280'
            }} data-id="element-276">
                Business Unit:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-277">
                Aisco Europe
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-278">
              <span style={{
              color: '#6b7280'
            }} data-id="element-279">
                Claim Type:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-280">
                Technical Issue
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-281">
              <span style={{
              color: '#6b7280'
            }} data-id="element-282">
                Customer:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-283">
                Dimitri Yakolev
              </span>
            </div>
          </div>
        </div>

        {/* Machine Details */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '24px'
      }} data-id="element-284">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-285">
            Machine Details
          </h3>
          <div style={{
          display: 'grid',
          gap: '12px'
        }} data-id="element-286">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-287">
              <span style={{
              color: '#6b7280'
            }} data-id="element-288">
                Serial Number:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-289">
                002457898987
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-290">
              <span style={{
              color: '#6b7280'
            }} data-id="element-291">
                Installation Date:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-292">
                May 17, 2025
              </span>
            </div>
          </div>
        </div>

        {/* Problem Description */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '32px'
      }} data-id="element-293">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '12px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-294">
            Problem Description
          </h3>
          <p style={{
          margin: '0',
          color: '#4b5563',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-295">
            Fallo de tarjeta SIM en Icontrol pump por cantidad de dias de
            inactividad. pedimos que nos envien tarjetas SIM de repuesto (en lo
            posible de "Telefonica" ya que es la compania que mejor cobertura
            ofrece en la zona.
          </p>
        </div>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-296">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-297">
            View full details
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0',
        textAlign: 'center'
      }} data-id="element-298">
          If you have questions about this decision, please contact us through
          Aisco Workspace.
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-299">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-300">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-301" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}